import { css } from 'emotion';

import theme from 'site-react/theme';

const displayReset = css`
  display: inline-block;
  font-size: 0;
`;

const Container = css`
  ${displayReset};
  padding: ${theme.spacing.md}px 0;
  position: relative;
`;

const LocationsContainer = css`
  ${Container};
  width: 640px;
`;

const GuidesContainer = css`
  ${Container};
  width: 640px;
`;

const Column = css`
  ${displayReset};
  vertical-align: top;
`;

const LocationsLeftColumn = css`
  ${Column};
  width: 36%;
  margin-left: ${theme.spacing.xxl}px;
  margin-right: ${theme.spacing.base * 5}px;
`;

const LocationsRightColumn = css`
  ${Column};
  width: 45.25%;
  margin-left: ${theme.spacing.base * 5}px;
  margin-right: ${theme.spacing.xxl}px;
`;

const GuidesLeftColumn = css`
  ${Column};
  width: 46%;
  margin-left: ${theme.spacing.xxl}px;
  margin-right: ${theme.spacing.base * 5}px;
`;

const GuidesRightColumn = css`
  ${Column};
  width: 35.25%;
  margin-left: ${theme.spacing.base * 5}px;
  margin-right: ${theme.spacing.xxl}px;
`;

const Title = css`
  ${theme.largeLabel};
  border-bottom: 1px solid ${theme.colors.neutral100};
  color: ${theme.colors.neutral900};
  display: inline-block;
  margin-bottom: ${theme.spacing.base * 3}px;
  padding: 0 0 ${theme.spacing.base * 3}px;
  text-shadow: rgba(${theme.colors.blackRgb}, 0.01) 0 0 1px;
  text-transform: uppercase;
  width: 100%;
`;

const TitleTopMarginModifier = css`
  margin-top: ${theme.spacing.lg}px;
`;

const List = css`
  ${displayReset};
  margin: 0;
  padding: 0;
  list-style: none;
`;

const PopularAreasList = css`
  ${List};
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  height: 320px;
`;

const ListItem = css`
  ${displayReset};
  margin: 0;
`;

const Image = css`
  ${displayReset};
  width: 100%;
`;

const ContentContainerStyles = css`
  ${displayReset};
  vertical-align: middle;
  margin-bottom: ${theme.spacing.md}px;
`;

const ImageContainer = css`
  ${ContentContainerStyles};
  margin-right: ${theme.spacing.md}px;
  width: 56px;
  height: 56px;
  border: 1px solid ${theme.colors.neutral100};
`;

const TextContainer = css`
  ${ContentContainerStyles};
  margin-right: ${theme.spacing.xl}px;
  width: ${theme.spacing.xs * 27}px;
`;

const GuidesTextWidthModifierLeft = css`
  width: ${theme.spacing.base * 43}px;
`;

const GuidesTextWidthModifierRight = css`
  width: ${theme.spacing.base * 28}px;
  margin-right: 0;
  vertical-align: top;
`;

const TextLink = css`
  ${theme.contentText2};
  margin: 0;

  &:hover,
  &:focus,
  &:active {
    text-decoration: none;
  }
`;

const SeeMoreLink = css`
  margin-left: ${theme.spacing.xl + theme.spacing.xxl}px;
`;

export {
  Column,
  LocationsContainer,
  LocationsLeftColumn,
  LocationsRightColumn,
  GuidesContainer,
  GuidesLeftColumn,
  GuidesRightColumn,
  GuidesTextWidthModifierLeft,
  GuidesTextWidthModifierRight,
  Image,
  ImageContainer,
  List,
  ListItem,
  PopularAreasList,
  SeeMoreLink,
  TextContainer,
  TextLink,
  Title,
  TitleTopMarginModifier,
};
export default {
  Column,
  LocationsContainer,
  LocationsLeftColumn,
  LocationsRightColumn,
  GuidesContainer,
  GuidesLeftColumn,
  GuidesRightColumn,
  GuidesTextWidthModifierLeft,
  GuidesTextWidthModifierRight,
  Image,
  ImageContainer,
  List,
  ListItem,
  PopularAreasList,
  SeeMoreLink,
  TextContainer,
  TextLink,
  Title,
  TitleTopMarginModifier,
};
